import {
  init_packingFunctions
} from "./chunk-YQWI6GVL.mjs";
import {
  init_kernelBlurVaryingDeclaration
} from "./chunk-ZR2AV6SX.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/kernelBlurFragment.js
var name, shader;
var init_kernelBlurFragment = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/kernelBlurFragment.js"() {
    "use strict";
    init_shaderStore();
    name = "kernelBlurFragment";
    shader = `#ifdef DOF
factor=sampleCoC(sampleCoord{X}); 
computedWeight=KERNEL_WEIGHT{X}*factor;sumOfWeights+=computedWeight;
#else
computedWeight=KERNEL_WEIGHT{X};
#endif
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCoord{X}))*computedWeight;
#else
blend+=texture2D(textureSampler,sampleCoord{X})*computedWeight;
#endif
`;
    ShaderStore.IncludesShadersStore[name] = shader;
  }
});

// node_modules/@babylonjs/core/Shaders/ShadersInclude/kernelBlurFragment2.js
var name2, shader2;
var init_kernelBlurFragment2 = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/kernelBlurFragment2.js"() {
    "use strict";
    init_shaderStore();
    name2 = "kernelBlurFragment2";
    shader2 = `#ifdef DOF
factor=sampleCoC(sampleCenter+delta*KERNEL_DEP_OFFSET{X});computedWeight=KERNEL_DEP_WEIGHT{X}*factor;sumOfWeights+=computedWeight;
#else
computedWeight=KERNEL_DEP_WEIGHT{X};
#endif
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter+delta*KERNEL_DEP_OFFSET{X}))*computedWeight;
#else
blend+=texture2D(textureSampler,sampleCenter+delta*KERNEL_DEP_OFFSET{X})*computedWeight;
#endif
`;
    ShaderStore.IncludesShadersStore[name2] = shader2;
  }
});

// node_modules/@babylonjs/core/Shaders/kernelBlur.fragment.js
var name3, shader3, kernelBlurPixelShader;
var init_kernelBlur_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/kernelBlur.fragment.js"() {
    init_shaderStore();
    init_kernelBlurVaryingDeclaration();
    init_packingFunctions();
    init_kernelBlurFragment();
    init_kernelBlurFragment2();
    name3 = "kernelBlurPixelShader";
    shader3 = `uniform sampler2D textureSampler;uniform vec2 delta;varying vec2 sampleCenter;
#ifdef DOF
uniform sampler2D circleOfConfusionSampler;float sampleCoC(in vec2 offset) {float coc=texture2D(circleOfConfusionSampler,offset).r;return coc; }
#endif
#include<kernelBlurVaryingDeclaration>[0..varyingCount]
#ifdef PACKEDFLOAT
#include<packingFunctions>
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float computedWeight=0.0;
#ifdef PACKEDFLOAT
float blend=0.;
#else
vec4 blend=vec4(0.);
#endif
#ifdef DOF
float sumOfWeights=CENTER_WEIGHT; 
float factor=0.0;
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter))*CENTER_WEIGHT;
#else
blend+=texture2D(textureSampler,sampleCenter)*CENTER_WEIGHT;
#endif
#endif
#include<kernelBlurFragment>[0..varyingCount]
#include<kernelBlurFragment2>[0..depCount]
#ifdef PACKEDFLOAT
gl_FragColor=pack(blend);
#else
gl_FragColor=blend;
#endif
#ifdef DOF
gl_FragColor/=sumOfWeights;
#endif
}`;
    ShaderStore.ShadersStore[name3] = shader3;
    kernelBlurPixelShader = { name: name3, shader: shader3 };
  }
});

export {
  kernelBlurPixelShader,
  init_kernelBlur_fragment
};
